import api from './api';

const assessmentService = {
  // Get all assessments
  getAssessments: async () => {
    try {
      // This would need to be implemented on the backend
      const response = await api.get('/customers/assessments');
      return response.data.data;
    } catch (error) {
      console.error('Error fetching assessments:', error);
      throw error;
    }
  },
  
  // Get assessment by ID
  getAssessment: async (id) => {
    try {
      // This would need to be implemented on the backend
      const response = await api.get(`/customers/assessments/${id}`);
      return response.data.data;
    } catch (error) {
      console.error(`Error fetching assessment ${id}:`, error);
      throw error;
    }
  },
  
  // Send assessment to CRM
  sendToCrm: async (assessmentId) => {
    try {
      const response = await api.post('/zapier/send-assessment', { assessmentId });
      return response.data;
    } catch (error) {
      console.error('Error sending assessment to CRM:', error);
      throw error;
    }
  }
};

export default assessmentService;